export default __webpack_public_path__ + "static/media/power.5a7030e3.svg";